<template>
    <div ref="container" class="custom-css-container"></div>
</template>
<script>
export default {
    name: 'custom-css',
    props: {
        blok: Object
    },
    mounted: function() {
        this.$refs.container.innerHTML = `<style>${this.$props.blok.css}</style>`
    }
}
</script>
